const features = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Order Management',
    description: 'Track every purchase, seller, price, and order status in one organized spreadsheet. Never lose track of a single item throughout your entire purchasing workflow.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Cost Calculator',
    description: 'Estimate international shipping expenses before submitting parcels. Compare carrier rates including DHL, EMS, and economy options across different weight brackets.',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Warehouse Organization',
    description: 'Manage stored products and shipment preparation with clarity. Know exactly what is in your Basetao warehouse and when items are ready for consolidation.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Product Research',
    description: 'Save product links, prices, and seller information systematically. Build a centralized research database to compare options and make informed buying decisions.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Budget Control',
    description: 'Calculate total spending including product costs, domestic and international shipping, and service fees. Optimize every purchasing decision with clear financial oversight.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Advanced Analytics',
    description: 'Understand your buying patterns with built-in dashboard views. Track spending trends, identify top-performing sellers, and discover optimization opportunities.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Use Basetao Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Transform your international shopping workflow with tools built specifically for Basetao users.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}